module.exports = {
      id: "android-small-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#android-small",
      toString: function () {
        return this.url;
      }
    }